import {
	FETCH_SHIPMENT_DETAIL,
	FAIL_FETCH_SHIPMENT_DETAIL,
	SET_SHIPMENT_DETAIL_DATA,
	RESET_SHIPMENT_DETAIL_STATE,
	GET_PDF_ITEMS_SHIPMENT,
	FAIL_GET_PDF_ITEMS_SHIPMENT,
	SET_PDF_ITEMS_SHIPMENT,
	CLEAR_PDF_ITEMS_SHIPMENT,
	SAVE_SHIPMENT_DETAIL,
	FAIL_SAVE_SHIPMENT_DETAIL,
	SUCCESS_SAVE_SHIPMENT_DETAIL,
	RESET_PROCESS_ERROR
} from '../actions';

const initials = {
	/*common*/
	isFetching: false,
	error: undefined,
	isProcessError: false,

	/*data*/
	data: [],

	/*PDF*/
	pdfPath : undefined,

	/*process*/
	isCompleteSaveDetails : false,

}

const initialState = Object.assign({},initials);

export default function shipmentDetailSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
    switch (action.type) {
		case FETCH_SHIPMENT_DETAIL:
			ret.isFetching = true;
			return ret;
		case FAIL_FETCH_SHIPMENT_DETAIL:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SET_SHIPMENT_DETAIL_DATA:
			ret.data = action.payload.data;
			ret.isFetching = false;
			return ret;

		case RESET_SHIPMENT_DETAIL_STATE:
			Object.keys(initials).forEach((key)=>{
				ret[key] = initials[key];
			})
			return ret;

		case GET_PDF_ITEMS_SHIPMENT:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_PDF_ITEMS_SHIPMENT:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SET_PDF_ITEMS_SHIPMENT:
			ret.pdfPath = action.payload.pdfPath;
			ret.isFetching = false;
			return ret;
		case CLEAR_PDF_ITEMS_SHIPMENT:
			ret.pdfPath = undefined;
			return ret;

		case SAVE_SHIPMENT_DETAIL:
			ret.isFetching = true;
			return ret;
		case FAIL_SAVE_SHIPMENT_DETAIL:
			ret.isFetching = false;
			return ret;
		case SUCCESS_SAVE_SHIPMENT_DETAIL:
			ret.isFetching = false;
			ret.isCompleteSaveDetails = true;
			return ret;
		case RESET_PROCESS_ERROR:
			ret.error = undefined;
			ret.isProcessError = false;
			return ret;
		default:
			return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shipment-detail.js